import { useState, useEffect } from 'react';
import { TopToolbar, AutocompleteInput, useRecordContext, ExportButton, Button, List, Datagrid, TextField, EmailField, TextInput, ReferenceInput, SelectInput, ReferenceField, Edit, SimpleForm, useGetList, useDataProvider, Create, required, DateTimeInput, DateField } from 'react-admin';
import IconAdd from '@mui/icons-material/Add';
import Typography from '@mui/material/Typography';
import {default as commonStyles} from "./../styles/common.js";
import { formLabelClasses } from '@mui/material';

export const PageListTitle = (props) => {
    return (<Typography
            variant="h5"
            style={commonStyles.subPageTitle}>
                {props.text}
            </Typography>);
};

export const PageEditTitle = (props) => {
    const record = useRecordContext();
    if (!record) return null;
    return (<Typography
            variant="h5"
            style={commonStyles.subPageTitle}>
                {props.text} #{record.id}
            </Typography>);
};

export const PageCreateTitle = (props) => {
    return (<Typography
            variant="h5"
            style={commonStyles.subPageTitle}>
                {props.text}
            </Typography>);
};

const ListActions = (props) => (
    <TopToolbar>
        <ExportButton/>
    </TopToolbar>
);

export const CatalogProductList = (props) => {
    var record = useRecordContext();
    if (!record || !record.id) return <span>Chargement</span>;
    var catalogId = record.id;

    return (
        <div>
            <p>Liste des produits :</p>
            <List exporter={false} filter={{ catalogId: catalogId }} resource="catalogProducts" basePath="" actions={<ListActions catalogId={catalogId}/>}>
                <Datagrid>
                    <TextField source="productId" label="ID Produit" />
                    <ReferenceField source="productId" reference="products" label="Catégorie">
                        <TextField source="productFamily" />
                    </ReferenceField>
                    <ReferenceField source="productId" reference="products" label="Nom du produit">
                        <TextField source="product" />
                    </ReferenceField>
                    <ReferenceField source="productId" reference="products" label="Détails">
                        <TextField source="details" />
                    </ReferenceField>
                    <ReferenceField source="productId" reference="products" label="Prix">
                        <TextField source="price" />
                    </ReferenceField>
                    <ReferenceField source="productId" reference="products" label="Prix professionnel">
                        <TextField source="businessPrice" />
                    </ReferenceField>
                </Datagrid>
            </List>
        </div>
    )
};